import React from "react";
import { Card, Button, Text, Flex } from "rebass";
import { CardHeader } from "../../../../Components";
import { Patient } from "../../../../Types";

export const LicenceCard: React.FC<{ patient: Patient }> = ({ patient }) => {
  return (
    <Card>
      <CardHeader
        headerText={"Licence"}
        right={<Button>Assign Licence</Button>}
      />
      <Flex justifyContent="space-between" padding={3}>
        <div>
          <Text>Activation Code: {patient.home_activation_code}</Text>
          <Text>Start Date:</Text>
          <Text>End Date:</Text>
        </div>
        <div>
          <Text>Auto Renew</Text>
          <Button variant="secondary">Email Instructions</Button>
        </div>
      </Flex>
    </Card>
  );
};
